import type { FC } from "react";

import type { Question } from "@ui/components/SobQuiz/SobQuiz.types";
import dompurify from "isomorphic-dompurify";

import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { Button } from "@jti/core-components/components/Button";
import { Card } from "@jti/core-components/components/Card";
import { Separator } from "@jti/core-components/components/Separator";

import styles from "./SobQuestion.module.scss";

const { sanitize } = dompurify;

export interface SobQuestionProps {
  question: Question;
  onAnswerSelect: (id: string) => void;
  title?: string;
  description?: string;
  isPending?: boolean;
}

export const SobQuestion: FC<SobQuestionProps> = ({
  question,
  onAnswerSelect,
  title,
  description,
  isPending = false,
}) => {
  const { possibleAnswers } = question;
  return (
    <Card title={title} description={description} data-testid="sob-question">
      <div className={styles.container}>
        <Separator />
        <div
          data-testid="sob-question-text"
          className={styles.questionText}
          dangerouslySetInnerHTML={{ __html: sanitize(question.question.title) }}
        />
        <div className={styles.answersContainer}>
          {possibleAnswers.map((answer) => (
            <Button
              key={answer.id}
              variant="text-muted"
              pending={isPending}
              onClick={() => onAnswerSelect(answer.id)}
              className={styles.answerButton}
              iconAfter={LongArrowForwardIcon}
            >
              {answer.title}
            </Button>
          ))}
        </div>
      </div>
    </Card>
  );
};
